module.exports = __webpack_public_path__ + "static/media/hp_06.0ebd72ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_06.jpg
// module id = 5817
// module chunks = 0